export const reducerFlags = { followSpan: true }
